// One widget filling a phone's screen: turned on its side, a chart gets the whole width. Close, Esc or Back leaves.

import { useEffect } from "react";
import { X } from "lucide-react";
import { useStore } from "../state/store";
import { WidgetTile } from "../widgets/WidgetTile";
import { closeFull, usePhone } from "./state";

export function PhoneFull() {
  const id = usePhone((s) => s.full);
  const w = useStore((s) => (id ? s.items[id] : undefined));
  // gone while it showed (deleted here or elsewhere): nothing left to show
  useEffect(() => {
    if (id && !w) closeFull();
  }, [id, w]);
  useEffect(() => {
    if (!id) return;
    const key = (e: KeyboardEvent) => e.key === "Escape" && closeFull();
    window.addEventListener("keydown", key);
    return () => window.removeEventListener("keydown", key);
  }, [id]);
  if (!w || w.kind !== "widget") return null;
  return (
    <div className="phone-full" role="dialog" aria-modal="true" aria-label={`${w.title || "Widget"}, full screen`}>
      <div className={`item widget type-${w.type} mobile-item phone-full-tile`} data-widget={w.id}>
        <WidgetTile item={w} readOnly={false} />
      </div>
      <button className="phone-full-close" onClick={closeFull} aria-label="Close full screen">
        <X size={18} /> Close
      </button>
    </div>
  );
}
